module.exports = __webpack_public_path__ + "static/18-konsulat-37f93cb889b471b3f7fa308373eb67e9.jpg";